export default __webpack_public_path__ + "static/media/litho-landing-page-img-09.d8a22438.jpg";